<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header clearfix">
                    <h3 class="page-title">{{ $t('words.basic_info') }}<span class="page-header-breadcrumb">></span>{{ $t('words.contract_info') }}</h3>
                </div>
                <ul class="nav nav-tab nav--tab" id="childTab" role="tablist">
                    <li class="nav-item">
                        <router-link class="nav-link active" id="contract-nav" :to="{ name: 'cms-preferences-general' }" aria-controls="general" aria-selected="false">{{ $t('words.contract_info') }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link  class="nav-link" id="service_account-nav" :to="{ name: 'cms-preferences-service_account' }" aria-controls="service_account" aria-selected="false">{{ $t('words.service_account')}}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link  class="nav-link" id="login_account-nav" :to="{ name: 'cms-preferences-login_account' }" aria-controls="login_account" aria-selected="false">{{ $t('words.login_account') }}</router-link>
                    </li>
                </ul>
            </div>
            <div class="module">
                <div class="module-body">
                    <div  v-if="contract_load && ('live_service_type' in contract)">
                        <table class="table">
                        <tr>
                            <td colspan="2" class="thead">{{ $t('words.service_duration') }}</td>
                            <td> {{ renderDate(contract.start_date) }} ~ {{ renderDate(contract.end_date) }}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="thead">{{ $t('words.service_type') }}</td>
                            <td><span v-if="loaded(contract.live_service_type)">{{ $t('words.' + contract.live_service_type) }}</span></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="thead">{{ $t('words.contract_channel_count') }}</td>
                            <td><span v-if="loaded(contract.live_max_channels)">{{ contract.live_max_channels }}</span></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="thead">{{ $t('words.max_fps') }}</td>
                            <td><span v-if="loaded(contract.live_max_fps)">{{ contract.live_max_fps }} FPS</span></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="thead">{{ $t('words.max_birate') }}</td>
                            <td><span v-if="loaded(contract.live_max_bitrate)">{{ fileSizeToHuman(contract.live_max_bitrate) }}bps</span></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="thead">{{ $t('words.concurrently_viewer_limit') }}</td>
                            <td>
                                    <span v-if="loaded(contract.live_use_concurrently_viewer_limit)" :class="contract.live_use_concurrently_viewer_limit? 'text__postive' :'text__negative'">
                                        {{ contract.live_use_concurrently_viewer_limit ? $t('words.use_yes'): $t('words.use_no')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td rowspan="3" class="thead">{{ $t('words.player') }} <span class="text__star">*</span></td>
                            <td class="thead">{{ $t('words.use_exclusive_player') }}</td>
                            <td><span v-if="loaded(contract.live_use_exclusive_player)" :class="contract.live_use_exclusive_player? 'text__postive' :'text__negative'">{{ contract.live_use_exclusive_player ? $t('words.use_yes'): $t('words.use_no')}}</span></td>
                        </tr>
                        <tr>
                            <td class="thead">{{ $t('words.use_duplicate_block') }}</td>
                            <td><span v-if="loaded(contract.live_duplicate_block)" :class="contract.live_duplicate_block ? 'text__postive' :'text__negative'">{{ contract.live_duplicate_block ? $t('words.use_yes'): $t('words.use_no')}}</span></td>
                        </tr>
                        <tr>
                            <td class="thead">{{ $t('words.use_capture_block') }}</td>
                            <td><span v-if="loaded(contract.live_capture_block_policy)" :class="contract.live_use_exclusive_player && contract.live_capture_block_policy ? 'text__postive' :'text__negative'">{{ contract.live_use_exclusive_player && contract.live_capture_block_policy ? $t('words.use_yes'): $t('words.use_no')}}</span></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="thead">{{ $t('words.use_timeshift') }} <span class="text__star">*</span></td>
                            <td><span v-if="loaded(contract.live_use_time_shift)" :class="contract.live_use_time_shift? 'text__postive' :'text__negative'">{{ contract.live_use_time_shift ? $t('words.use_yes'): $t('words.use_no')}}</span></td>
                        </tr>
                        <tr>
                            <td rowspan="2" class="thead">{{ $t('words.recording_file_transfer') }}</td>
                            <td class="thead">{{ $t('words.use_yes_no') }} <span class="text-tooltip v-tooltip-open" v-tooltip="{ content: $t('paragraphs.downloadable_within_7_days') }"><i class="icon icon-info-circle-line"></i></span></td>
                            <td><span v-if="loaded(contract.live_use_recording_file)" :class="contract.live_use_recording_file? 'text__postive' :'text__negative'">{{ contract.live_use_recording_file ? $t('words.use_yes'): $t('words.use_no')}}</span></td>
                        </tr>
                        <tr>
                            <td class="thead">{{ $t('words.forwarding_target_limit_count') }}</td>
                            <td><span v-if="loaded(contract.live_max_recording_files_per_channel)"></span>{{ contract.live_max_recording_files_per_channel === 0 ? $t('words.no_limit'): contract.live_max_recording_files_per_channel}}</td>
                        </tr>
                        <tr>
                            <td rowspan="2" class="thead">{{ $t('words.syndication') }}</td>
                            <td class="thead">{{ $t('words.use_yes_no') }}</td>
                            <td><span v-if="loaded(contract.live_use_syndication)" :class="contract.live_use_syndication? 'text__postive' :'text__negative'">{{ contract.live_use_syndication ? $t('words.use_yes'): $t('words.use_no')}}</span></td>
                        </tr>
                        <tr>
                            <td class="thead">{{ $t('words.forwarding_target_limit_count') }}</td>
                            <td><span v-if="loaded(contract.live_max_syndication_per_channel)">{{ contract.live_max_syndication_per_channel === 0 ? $t('words.no_limit'): contract.live_max_syndication_per_channel}}</span></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="thead">{{ $t('words.snapshot') }} <span class="text__star">*</span></td>
                            <td><span v-if="loaded(contract.live_use_snapshot)" :class="contract.live_use_snapshot? 'text__postive' :'text__negative'">{{ contract.live_use_snapshot ? $t('words.use_yes'): $t('words.use_no')}}</span></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="thead">{{ $t('words.mobile_encoder_sdk') }} <span class="text__star">*</span></td>
                            <td><span v-if="loaded(contract.live_use_mobile_encoder_sdk)" :class="contract.live_use_mobile_encoder_sdk? 'text__postive' :'text__negative'">{{ contract.live_use_mobile_encoder_sdk ? $t('words.use_yes'): $t('words.use_no')}}</span><button class="btn btn-sm ml-3" @click="showLicenseModal()" >{{ $t('words.license_key') }}</button></td>
                        </tr>
                        <tr>
                            <td rowspan="2" class="thead">{{ $t('words.chatting') }} <span class="text__star">*</span></td>
                            <td class="thead">{{ $t('words.use_yes_no') }}</td>
                            <td><span v-if="loaded(contract.live_use_chatting_service)" :class="contract.live_use_chatting_service? 'text__postive' :'text__negative'">{{ contract.live_use_chatting_service ? $t('words.use_yes'): $t('words.use_no')}}</span></td>
                        </tr>
                        <tr>
                            <td class="thead">{{ $t('words.type') }}</td>
                            <td>
                                <span v-if="loaded(contract.live_use_chatting_service)"></span>
                                <span v-if="contractChatting && contractChatting.kind.type  === 'chatroll'">{{ $t('words.chatting_type_embed')}}</span>
                                <span v-if="contractChatting && contractChatting.kind.type  === 'kollus'">Kollus</span>
                            </td>
                        </tr>
                            <tr>
                                <td colspan="2" class="thead">{{ $t('words.file_live') }} <span class="text__star">*</span></td>
                                <td><span v-if="loaded(contract.live_use_file_to_live)" :class="contract.live_use_file_to_live? 'text__postive' :'text__negative'">{{ contract.live_use_file_to_live ? $t('words.use_yes'): $t('words.use_no')}}</span></td>
                            </tr>
                        </table>
                        <p class="text-guide mt-sp mb-0">(<span class="text__star">*</span>) {{ $t('paragraphs.contract_tip1')}}</p>
                    </div>
                    <div v-else-if="contract_load">
                        <h4>
                            <span class="fa fa-exclamation"></span>
                            {{ $t('paragraphs.has_no_contract') }}
                        </h4>
                        <p>
                            {{ $t('paragraphs.has_no_contract_detail') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="licensesModal" tabindex="-1" role="dialog" aria-labelledby="licensesModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="hideChannelModalLabel">{{ $t('words.license_key') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pb-0">
                        <div class="action-group">
                            <div class="form-inline float-left">
                                <div class="control-group" style="width:120px;">
                                    <label for="select_kind" class="sr-only">OS</label>
                                    <select id="select_kind" data-placeholder="OS">
                                        <option :value="kind" v-for="kind in kinds" :key="kind">
                                            {{ kind === ''? $t('words.all') : $t('words.' + kind) }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <nav aria-label="Page navigation" class="ml-auto">
                                <ul class="pagination" v-if="licenses.meta.last_page !== 1">
                                    <li class="page-info">
                                    <span>
                                    {{ $t('paragraphs.page_navigation', { total: licenses.meta.total, from: ((licenses.meta.current_page - 1) * licenses.meta.per_page + 1), to: (licenses.meta.current_page === licenses.meta.last_page ? licenses.meta.total : licenses.meta.per_page * licenses.meta.current_page)}) }}
                                    </span>
                                    </li>
                                    <li :class="{'page-item': true, disabled: !licenses.links.prev }">
                                        <button class="page-link" aria-label="Previous" @click="loadLicenses(licenses.links.prev)" v-if="licenses.links.prev">
                                            <i aria-hidden="true" class="icon icon-arrow-left-sm"></i>
                                            <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                        </button>
                                        <button class="page-link" aria-label="Previous" v-else>
                                            <i aria-hidden="true" class="icon icon-arrow-left-sm"></i>
                                            <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                        </button>
                                    </li>
                                    <li :class="{'page-item': true, disabled: !licenses.links.next }">
                                        <button class="page-link" aria-label="Next" @click="loadLicenses(licenses.links.next)" v-if="licenses.links.next">
                                            <i aria-hidden="true" class="icon icon-arrow-right-sm"></i>
                                            <span class="sr-only">{{ $t('pagination.next') }}</span>
                                        </button>
                                        <button class="page-link disabled" aria-label="Previous" disabled v-else>
                                            <i aria-hidden="true" class="icon icon-arrow-tight-sm"></i>
                                            <span class="sr-only">{{ $t('pagination.next') }}</span>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                        <div class="table__wide">
                            <table class="table mb-0">
                                <thead>
                                <tr>
                                    <th class="td__checkbox">No</th>
                                    <th>{{ $t('words.create_date') }}</th>
                                    <th>{{ $t('words.expire_date') }}</th>
                                    <th>OS</th>
                                    <th>{{ $t('words.package_name/bundle_id') }}</th>
                                    <th>{{ $t('words.authentication_key') }}</th>
                                    <th>Proxy Port</th>
                                </tr>
                                </thead>
                                <tbody v-if="licenses.load && (licenses.meta.total !== 0)">
                                <tr v-for="(license, index) in licenses.data" :key="license.id">
                                    <td class="td__checkbox">
                                        {{ ((licenses.meta.current_page - 1) * licenses.meta.per_page + 1) + index }}
                                    </td>
                                    <td>{{ renderDate(license.start_date)}}</td>
                                    <td>{{ renderDate(license.end_date)}}</td>
                                    <td>{{ $t('words.' + license.kind) }}</td>
                                    <td style="word-break: break-all">{{license.bundle_name }}</td>
                                    <td style="word-break: break-all">{{license.authentication_key }}</td>
                                    <td>{{license.proxy_port }}</td>
                                </tr>
                                </tbody>
                                <tbody v-else-if="licenses.load">
                                <tr>
                                    <td colspan="7" class="td__message">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.license_key_empty') }}</td>
                                </tr>
                                </tbody>
                                <tbody v-else>
                                <tr>
                                    <td colspan="5" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="ml-auto">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                {{ $t('words.close') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';
import DateTimeMixin from '../mixin/DateTimeMixin';

export default {
    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],
    data() {
        return {
            kinds: ['', 'android', 'ios'],
            selectedKind: '',
            contract: {
            },
            contract_load: false,
            licenses: {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            },
        };
    },
    beforeMount() {
    },
    mounted() {
        const self = this;
        $('#select_kind').selectize({
            maxItems: 1,
            create: true,
            // sortField: 'text',
            onChange(value) {
                self.selectedKind = value;
            },
        });
        if (this.loadedServiceAccount) {
            this.loadContract();
        }
    },
    methods: {
        fileSizeToHuman(raw) {
            let number = raw;
            if (number <= 0) {
                return number;
            }
            const units = ['', 'K', 'M', 'G', 'T', 'P'];
            let i;
            for (i = 0; number >= 1000; i += 1) {
                number /= 1000;
            }

            return `${(Math.round(number * 100) / 100)} ${units[i]}`;
        },
        loaded(field) {
            return typeof field !== 'undefined';
        },
        loadContract() {
            axios.get(this.contractApiUri).then((response) => {
                this.contract = response.data.data;
                this.contract_load = true;
            }).catch((error) => {
                this.contract_load = true;
            });
        },
        loadLicenses(licenseApiUri) {
            this.licenses.load = false;
            axios.get(licenseApiUri).then((response) => {
                this.licenses = response.data;
                this.licenses.load = true;
            });
        },
        showLicenseModal() {
            this.loadLicenses(this.licenseApiUri);
            $('#licensesModal').modal();
        },
    },
    computed: {
        licenseApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/licenses?kind=${this.selectedKind}`;
        },
        contractApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/contract`;
        },
        contractChatting() {
            if (this.selectedServiceAccount.chatting_service
                && ('id' in this.selectedServiceAccount.chatting_service)) {
                return this.selectedServiceAccount.chatting_service;
            }
            return null;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.loadContract();
        },
        selectedKind() {
            this.loadLicenses(this.licenseApiUri);
        },
    },
};
</script>

<style scoped>
.table .thead {
    width: 25%;
}
</style>
